import { Controller } from "@hotwired/stimulus";

export class ManagedModalController extends Controller {
  static targets = [
    "form",
    "modal",
    "jobTitle",
    "startDate",
    "endDate",
    "company",
    "location",
    "contactName",
    "contactEmail",
    "contactPhone",
    "mainResponsabilities",
    "currentJob",
  ];

  static values = {
    id: String,
    jobTitle: String,
    startDate: String,
    endDate: String,
    company: String,
    location: String,
    contactName: String,
    contactEmail: String,
    contactPhone: String,
    mainResponsabilities: String,
    currentJob: Boolean,
  };

  connect() {
    this.formTarget.action = `/users/update-work-experience/${this.idValue}`;
  }

  open(event) {
    this.jobTitleTarget.value = this.jobTitleValue;
    this.startDateTarget.value = this.startDateValue;
    this.endDateTarget.value = this.endDateValue;
    this.companyTarget.value = this.companyValue;
    this.locationTarget.value = this.locationValue;
    this.contactNameTarget.value = this.contactNameValue;
    this.contactEmailTarget.value = this.contactEmailValue;
    this.contactPhoneTarget.value = this.contactPhoneValue;
    this.mainResponsabilitiesTarget.value = this.mainResponsabilitiesValue;
    this.currentJobTarget.checked = this.currentJobValue;
    if (this.currentJobTarget.checked) {
      this.endDateTarget.setAttribute("disabled", "");
    }

    this.modalTarget.showModal();
  }

  close(event) {
    this.modalTarget.close();
  }

  submit(event) {
    event.preventDefault();
    if (!this.formTarget.checkValidity()) {
      this.formTarget.reportValidity();
      return;
    } else {
      this.formTarget.requestSubmit();
      return;
    }
  }
}
